import { useState } from 'react'
import { sx } from '../lib/sx'

/**
 * Small info affordance that reveals a note on hover, and pins it on click so
 * the text survives a pointer that wanders — and so it is reachable at all on
 * a touchscreen or by keyboard.
 */
export function InfoTip({ text, label }: { text: string; label: string }) {
  const [hovered, setHovered] = useState(false)
  const [pinned, setPinned] = useState(false)
  const open = hovered || pinned

  return (
    <span style={sx('position:relative;display:flex;flex:none')}>
      <button
        type="button"
        aria-label={label}
        aria-expanded={open}
        onClick={(e) => {
          // The whole card selects a flow; the info button must not.
          e.stopPropagation()
          setPinned((p) => !p)
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onFocus={() => setHovered(true)}
        onBlur={() => setHovered(false)}
        style={sx(
          'width:20px;height:20px;padding:0;border:none;background:transparent;cursor:pointer;' +
            'display:flex;align-items:center;justify-content:center'
        )}
      >
        <span
          style={sx(
            `width:15px;height:15px;background:${open ? 'var(--text-accent)' : 'var(--text-secondary)'};` +
              'transition:background 150ms var(--ease-out);' +
              '-webkit-mask:url(/assets/icons/info.svg) center/contain no-repeat;' +
              'mask:url(/assets/icons/info.svg) center/contain no-repeat'
          )}
        />
      </button>

      {open ? (
        <span
          role="tooltip"
          style={sx(
            'position:absolute;top:calc(100% + 8px);right:-4px;z-index:20;width:262px;' +
              'padding:12px 14px;border-radius:var(--radius-md);background:var(--bg-tertiary);' +
              'border:1px solid var(--border-primary);box-shadow:var(--shadow-modal);' +
              'font-size:var(--fs-xs);line-height:18px;color:var(--text-primary);' +
              'font-weight:var(--fw-normal);text-transform:none;letter-spacing:0;' +
              'animation:gpop 150ms var(--ease-out)'
          )}
        >
          {text}
        </span>
      ) : null}
    </span>
  )
}
